import { useRef, useState } from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
import { UNLINKED_PARTICIPANTS, CANCEL, FIND_PATIENT_MATCH, FIND } from "../../util/const";
import { Participant } from "../../types/participant";
import { HomePageProps } from "../PatientList";
import OrphanParticipants from "../OrphanParticipants";
import PossibleMatches from "../PossibleMatches";


const  UnlinkedParticipants = (props: HomePageProps) => {

  const [isFinding, setIsFinding] = useState(false);
  const selectedParticipant = useRef<Participant>();

  const onFindOrCancel = (subject?: Participant) => {
    selectedParticipant.current = subject;
    toggleDisplay(subject === undefined);
  }

  const toggleDisplay = (didComplete: boolean) => {
    if(didComplete)
      props.toggleDisplay(didComplete);
    else
      setIsFinding(!isFinding);
  }

  if (isFinding)
    return <PossibleMatches toggleDisplay={toggleDisplay} participant={selectedParticipant.current!} />
  
  return (
    <>
      <Card className="mt-3 mb-3" border="secondary" text="white">
        <Card.Header className="fs-5 app-colour">
          <Row>
            <Col>{UNLINKED_PARTICIPANTS}</Col>
            <Col className="right">
              <Button type="button" onClick={(e) => props.toggleDisplay(true)} className='fs-6 btn-outline-white'>{CANCEL}</Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <OrphanParticipants actionHeaderText={FIND_PATIENT_MATCH} actionText={FIND} parentCallback={onFindOrCancel} />
        </Card.Body>
      </Card>
    </>
  );
}

export default UnlinkedParticipants;